import { useMemo, useCallback } from 'react';
import messagesData from './messages.json';
import { getLanguage } from '../../../i18n';

interface MessageBody {
  en: string;
  de: string;
  es: string;
  fr: string;
  [key: string]: string;
}

interface LoginMessage {
  title: string | null;
  body: MessageBody;
  severity: 'error' | 'warning' | 'info' | 'success';
  showAfter: string | null;
  showBefore: string | null;
}

export function useLoginMessages(language: string = getLanguage()) {
  const getMessageBody = useCallback(
    (message: LoginMessage): string => {
      return message.body[language] || message.body.en;
    },
    [language]
  );
  const activeMessages = useMemo(() => {
    const currentDate = new Date();

    return (messagesData.messages as LoginMessage[]).filter(
      (message: LoginMessage) => {
        const showAfter = message.showAfter
          ? new Date(message.showAfter)
          : null;
        const showBefore = message.showBefore
          ? new Date(message.showBefore)
          : null;

        if (showAfter && currentDate < showAfter) return false;
        if (showBefore && currentDate > showBefore) return false;
        if (getMessageBody(message).trim() === '') return false;
        return true;
      }
    );
  }, [language]);

  return {
    activeMessages,
    getMessageBody,
  };
}
